import * as actionType from "../constants";

export const statusChangeMessage = () => async (dispatch) => {
  dispatch({ type: actionType.SHOW_STATUS_CHANGE });
  setTimeout(() => {
    dispatch({ type: actionType.HIDE_STATUS_CHANGE });
  }, 4000);
};
